import {  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-sku-details-dropdown',
  templateUrl: './sku-details-dropdown.component.html',
  styleUrl: './sku-details-dropdown.component.scss'
})
export class SkuDetailsDropdownComponent {
  @Input() dropdownOptions: any[] = [];
  @Output() actionBtnCallback = new EventEmitter<any>();

  selectedRegion: string = "";

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      let options = changes?.dropdownOptions?.currentValue;
      this.selectedRegion = options[0]?.value;
    }
  }

  onLevelChange() {
    this.actionBtnCallback.emit(this.selectedRegion);
  }
}
